module.exports = __webpack_public_path__ + "images/snappcar565c7b83989318d850375035c17680c4.png";